"use client"

import React, { useEffect, useMemo, useState } from "react"
import { motion } from "framer-motion"
import { CreditCard, AlertTriangle, MessageCircle, ExternalLink } from "lucide-react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "https://api.ticketdovaqueiro.com/api"

export default function CartaoManualCircuito({ pedidoId, valor = 0, nomeEvento = "Associação ao Circuito" }) {
  const [destino, setDestino] = useState("")
  const [nomeVaqueiro, setNomeVaqueiro] = useState("Vaqueiro")

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"))
      if (user && user.nomeCompleto) {
        setNomeVaqueiro(user.nomeCompleto)
      }
    } catch (e) {
      console.error("Erro ao ler dados do usuário", e)
    }
  }, [])

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/gateways`)
        const phone = data?.credentials?.cartao_manual?.whatsappDestino || ""
        setDestino((phone || "").replace(/\D/g, ""))
      } catch (e) {
        console.warn("Falha ao carregar WhatsApp destino do Cartão Manual.", e)
      }
    })()
  }, [])

  const msg = useMemo(() => {
    const v = Number(valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
    return `Olá! Gostaria de solicitar o *link de pagamento no cartão de crédito*.

• *Evento:* ${nomeEvento}
• *Pedido:* ${pedidoId || "-"}
• *Nome:* ${nomeVaqueiro}
• *Total:* ${v}

Aguardo o link para finalizar minha inscrição!`
  }, [pedidoId, valor, nomeVaqueiro, nomeEvento])

  const waLink = useMemo(() => {
    const encoded = encodeURIComponent(msg)
    return destino ? `https://wa.me/55${destino}?text=${encoded}` : `https://wa.me/?text=${encoded}`
  }, [destino, msg])

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4 }}
      style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 24 }}>
        <CreditCard size={24} color="var(--c-accent)" />
        <h3 style={{ fontSize: "18px", fontWeight: 700, color: "#fff", margin: 0 }}>Pagamento via Cartão</h3>
      </div>

      <div style={{ width: "100%", maxWidth: 420, display: "flex", flexDirection: "column", alignItems: "center" }}>
        
        <div style={{ 
          width: "100%", 
          background: "rgba(255,255,255,0.03)", 
          border: "1px solid rgba(255,255,255,0.08)", 
          borderRadius: 16, 
          padding: 24, 
          marginBottom: 24,
          textAlign: "center"
        }}>
          <MessageCircle size={40} color="var(--c-accent)" style={{ marginBottom: 16, opacity: 0.8 }} />
          <h4 style={{ fontSize: "18px", color: "#fff", fontWeight: 700, margin: "0 0 8px 0" }}>
            Atendimento Personalizado
          </h4>
          <p style={{ color: "#fff", opacity: 0.7, fontSize: "14px", lineHeight: "1.6", margin: 0 }}>
            Para garantir a sua segurança e aplicar as taxas corretas, o pagamento no cartão de crédito é feito através de um <strong>link exclusivo</strong> enviado pela nossa equipe de atendimento.
          </p>
        </div>

        <div style={{ 
          display: "flex", alignItems: "flex-start", gap: 12, width: "100%",
          padding: "16px", background: "rgba(245, 158, 11, 0.1)", borderRadius: 12, 
          border: "1px solid rgba(245, 158, 11, 0.2)", color: "#fcd34d", marginBottom: 24
        }}>
          <AlertTriangle size={24} style={{ flexShrink: 0, marginTop: 2 }} />
          <div style={{ fontSize: "13px", lineHeight: "1.5" }}>
            <strong style={{ display: "block", fontSize: "14px", marginBottom: 4, color: "#fbbf24" }}>Atenção às Taxas</strong>
            <span style={{ color: "#fff", opacity: 0.8 }}>
              Na modalidade de cartão de crédito, existe um acréscimo automático no valor gerado pelo sistema da operadora (Gateway de Pagamento).
            </span>
          </div>
        </div>

        <a
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", width: "100%" }}
        >
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            style={{ 
              width: "100%", 
              height: "56px", 
              fontSize: "16px", 
              fontWeight: 800, 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center", 
              gap: 10,
              background: "#25D366",
              color: "#fff",
              border: "none",
              borderRadius: "12px",
              cursor: "pointer",
              boxShadow: "0 4px 20px rgba(37, 211, 102, 0.3)"
            }}
          >
            <MessageCircle size={20} />
            Solicitar Link no WhatsApp
            <ExternalLink size={16} style={{ opacity: 0.6, marginLeft: 4 }} />
          </motion.button>
        </a>

        <p style={{ color: "#fff", opacity: 0.5, fontSize: "12px", textAlign: "center", marginTop: 16 }}>
          Ao clicar, você será redirecionado para o nosso WhatsApp oficial.
        </p>
      </div>
    </motion.div>
  )
}